module.exports = __webpack_public_path__ + "static/tusd-icon-495630fd0a46d8e5d77207f62c40dbd1.png";